import { API } from "aws-amplify";
import { useCallback } from "react";
import { GraphQLQuery } from "@aws-amplify/api";

import { getAuthCookie, } from "../utils/cookies";

import { addEmailToPayment as addEmailToPaymenwtGqlMutation } from "../graphql/mutations";
import {
    AddEmailToPaymentInput,
    AddEmailToPaymentMutation,
} from "../API";


export function useAddEmailToPayment() {
    const addEmailToPayment = useCallback(
        async (
            input: AddEmailToPaymentInput
        ): Promise<boolean | null> => {
            try {
                const { identityId, refreshToken } = getAuthCookie();
                console.log("[addEmailToPayment] ", { identityId, refreshToken });
                const result = await API.graphql<
                    GraphQLQuery<AddEmailToPaymentMutation>
                >({
                    query: addEmailToPaymenwtGqlMutation,
                    variables: { input: { ...input, identityId: refreshToken ? undefined : identityId } },
                    authToken: refreshToken || undefined
                });

                if (result.errors) {
                    return false;
                }

                if (!result.data) {
                    return false;
                }

                return (result.data?.addEmailToPayment !== undefined && result.data?.addEmailToPayment !== null) ? result.data.addEmailToPayment : false;
            } catch (e: any) {
                console.log("[addEmailToPayment]", e);
                return false;
            }
        },
        []
    );

    return { addEmailToPayment };
}
